<template>
  <b-container fluid class="py-3">
    <b-row>
      <b-col>
        <Tableview
          v-model:value="items"
          :paginator="true"
          class="p-datatable-gridlines"
          :rows="10"
          :rowHover="true"
          filterDisplay="menu"
          :loading="loading"
          responsiveLayout="scroll"
          :columns="headers"
          dataKey="ID"
          :selection-mode="false"
          @row-click="RowClick"
          :subColumns="subheaders"
          @expandRows="ExpandRows"
          :SubList="SubList"
          :expandSubRows="true"
        >
          <template v-slot:DebitNotesApplied="{ data }">
            <div>{{ data.DebitNoteCode }} (Rs.{{ data.DebitNoteAmount }})</div>
          </template>
          <template v-slot:PrePaymentsUsed="{ data }">
            <div>
              {{ data.PrepaymentCode }} (Rs.{{ data.PrepaymentsAmount }})
            </div>
          </template>
          <template v-slot:ApprovalStatusSlot="{ data }">
            <OrangeStatus
              name="Approval Pending"
              v-if="data.ApprovalStatus == '0'"
            />
            <GreenStatus name="Approved" v-if="data.ApprovalStatus == '1'" />
            <OrangeStatus
              name="Payment Pending"
              v-if="data.ApprovalStatus == '2'"
            />
            <RedStatus
              name="Approval Rejected"
              v-if="data.ApprovalStatus == '3'"
            />
          </template>
          <template v-slot:PaymentStatus="{ data }">
            <div v-if="data.PaymentStatus == 0">
              {{ "Pending" }}
            </div>
            <div v-else>
              {{ "Completed" }}
            </div>
          </template>
        </Tableview>
      </b-col>
    </b-row>
  </b-container>
</template>

<script lang="ts">
import { defineComponent, ref, computed, watch } from "vue";
import Tableview from "../../../../../../components/FormComponents/NormalTable.vue";
import { useRouter, useRoute } from "vue-router";
import SupplierPaymentMasterService from "../../../../../../modules/Inventory/Service/SupplierPaymentMasterService";
import moment from "moment";
import PoApprovalService from "../../../../../../modules/Inventory/Service/PoApprovalService";

export default defineComponent({
  components: {
    Tableview,
  },
  props: {
    datas: {
      type: Array,
      default: [],
    },
    activeIndex: {
      type: Number,
      default: 0,
    },
    IsApprovalStatus: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, { emit }) {
    //Declaration
    const router = useRouter();
    const route = useRoute();

    let items = ref([]);
    let SubList = ref([]);
    const loading = ref(false);
    const activeTabIndex = ref(props.activeIndex);
    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }
    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }
    //DataTable Fields

    const headers = [
      {
        header: "Payment Id",
        field: "PaymentCode",
        class: "filterdisplaynone",
      },
      {
        header: "Date",
        field: "PaymentDate",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
      },
      {
        header: "Amount Paid",
        field: "PaymentAmount",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
      },
      {
        header: "Payment Method",
        field: "PaymentMethod",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
      },
      {
        header: "TDSAmount",
        field: "TDSAmount",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
      },
      {
        header: "TAXAmount",
        field: "TAXAmount",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
      },
      {
        header: "Approval Status",
        slot: "ApprovalStatusSlot",
        field: "",
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
        class: "mediumwidth columnfreezerightId1",
      },
    ];
    const subheaders = [
      {
        header: "RowNumber",
        field: "RowNumber",
        class: "filterdisplaynone",
      },
      {
        header: "PO Code",
        field: "POCode",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
      },
      {
        header: "Invoice Code",
        field: "InvoiceCode",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
      },
      // {
      //     header: "Invoice Amount",
      //     field: "InvoiceAmount",
      //     filterTemplate: "MultiSelect",
      //     ShowMactchMode: false,
      //     bodyclass: 'boldclass',
      // },

      {
        header: "PaymentTerms",
        field: "PaymentTerms",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
      },
      {
        header: "Payment Amount",
        field: "PaymentAmount",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
      },
      // {
      //     header: "PrepaymentCode",
      //     field: "PrepaymentCode",
      //     filterTemplate: "MultiSelect",
      //     ShowMactchMode: false,
      //     bodyclass: 'boldclass',
      // },
      // {
      //     header: "PrepaymentAmount",
      //     field: "PrepaymentsAmount",
      //     filterTemplate: "MultiSelect",
      //     ShowMactchMode: false,
      //     bodyclass: 'boldclass',
      // },
      // {
      //     header: "DebitNoteCode",
      //     field: "DebitNoteCode",
      //     filterTemplate: "MultiSelect",
      //     ShowMactchMode: false,
      //     bodyclass: 'boldclass',
      // },
      // {
      //     header: "DebitNoteAmount",
      //     field: "DebitNoteAmount",
      //     filterTemplate: "MultiSelect",
      //     ShowMactchMode: false,
      //     bodyclass: 'boldclass',
      // },
    ];

    const supplierdatas: any = ref(props.datas);
    watch(
      () => props.datas,
      (newVal: any) => {
        supplierdatas.value = newVal;
        activeTabIndex.value = 0;
        IsShow();
      },
      { deep: true }
    );
    watch(
      () => props.activeIndex,
      (newVal: any) => {
        IsShow();
      },
      { deep: true }
    );
    watch(
      () => props.IsApprovalStatus,
      (newVal: any) => {
        IsShow();
      },
      { deep: true }
    );
    async function IsShow() {
      debugger;
      debugger;
      try {
        loading.value = true;
        let count = 0;
        const dataresponse = await SupplierPaymentMasterService.GetBySupplierId(
          supplierdatas.value.SupplierId,
          usersData.OrganizationId,
          usersData.BranchId,
          route.query.StoreId
        );
        items.value = dataresponse["result"].map((item: any) => {
          count = count + 1;
          item.RowNumber = count;
          item.ApprovalType = 1;
          return item;
        });
        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    }
    function RowClick(event: any) {
      emit("ApprovalDetailsData", event.data);
    }
    async function ExpandRows(data) {
      debugger;
      loading.value = true;
      let count = 0;
      const dataresponse = await SupplierPaymentMasterService.GetByPaymentId(
        data.PaymentID
      );
      SubList.value = dataresponse["result"].map((item: any) => {
        count = count + 1;
        item.RowNumber = count;
        return item;
      });
      loading.value = false;
    }

    return {
      items,
      loading,
      headers,
      activeTabIndex,
      IsShow,
      RowClick,
      subheaders,
      ExpandRows,
      SubList,
    };
  },
});
</script>

<style lang="scss" scoped>
.columnfreezerightId1 {
  position: sticky;
  right: -16px;
  z-index: 1;
  width: 40px !important;
  background-color: #e1e1e1;
}
</style>
